var _excluded = ["hitComponent", "hits", "sendEvent", "isFirstPage", "isLastPage", "onShowPrevious", "onShowMore", "classNames", "translations"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { cx } from "./lib/cx.js";
function DefaultHitComponent(_ref) {
  var hit = _ref.hit;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: 'break-all'
    }
  }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
export function InfiniteHits(_ref2) {
  var _ref2$hitComponent = _ref2.hitComponent,
    HitComponent = _ref2$hitComponent === void 0 ? DefaultHitComponent : _ref2$hitComponent,
    hits = _ref2.hits,
    sendEvent = _ref2.sendEvent,
    isFirstPage = _ref2.isFirstPage,
    isLastPage = _ref2.isLastPage,
    onShowPrevious = _ref2.onShowPrevious,
    onShowMore = _ref2.onShowMore,
    _ref2$classNames = _ref2.classNames,
    classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
    translations = _ref2.translations,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('ais-InfiniteHits', classNames.root, hits.length === 0 && cx('ais-InfiniteHits--empty', classNames.emptyRoot), props.className)
  }), onShowPrevious && /*#__PURE__*/React.createElement("button", {
    className: cx('ais-InfiniteHits-loadPrevious', classNames.loadPrevious, isFirstPage && cx('ais-InfiniteHits-loadPrevious--disabled', classNames.disabledLoadPrevious)),
    onClick: onShowPrevious,
    disabled: isFirstPage
  }, translations.showPreviousButtonText), /*#__PURE__*/React.createElement("ol", {
    className: cx('ais-InfiniteHits-list', classNames.list)
  }, hits.map(function (hit) {
    return /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: cx('ais-InfiniteHits-item', classNames.item),
      onClick: function onClick() {
        sendEvent('click:internal', hit, 'Hit Clicked');
      }
    }, /*#__PURE__*/React.createElement(HitComponent, {
      hit: hit,
      sendEvent: sendEvent
    }));
  })), /*#__PURE__*/React.createElement("button", {
    className: cx('ais-InfiniteHits-loadMore', classNames.loadMore, isLastPage && cx('ais-InfiniteHits-loadMore--disabled', classNames.disabledLoadMore)),
    onClick: onShowMore,
    disabled: isLastPage
  }, translations.showMoreButtonText));
}